export enum FormEvent {
  ON_INPUT_FOCUS = 'FormEvent:focus',
  ON_INPUT_BLUR = 'FormEvent:blur'
}
